import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { registerWorker } from './push';
import './styles.css';

/*
 * Before React, and before any session is known.
 *
 * Chrome offers to install a site only once a service worker with a `fetch` handler is
 * registered, so registering it from inside the notifications panel meant the install prompt
 * arrived after signing in — useless to a learner whose only way of being reached is push,
 * who needs the app on their home screen before they have an account. See `registerWorker`;
 * it cannot throw and is not awaited, so nothing below waits on it and no browser that
 * refuses service workers loses the site.
 */
registerWorker();

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
